import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import * as DatabaseLib from '@/assets/js/DatabaseLib.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: sessionStorage.getItem('token') || "",
    user: sessionStorage.getItem('user') || "",
    id: sessionStorage.getItem('id') || "",
    email: sessionStorage.getItem('email') || "",
    role: sessionStorage.getItem('role') || "",
    groups: sessionStorage.getItem('groups') || "",
    ccb_projects: sessionStorage.getItem('ccb_projects') || "",
    avatar: sessionStorage.getItem('avatar') || "",
    status: ""
  },
  mutations: {
    auth_request(state) {
    state.status = 'loading';
  },
  auth_success(state, payload) {
    state.status = 'success';
    state.token = payload.token;
    state.user = payload.user;
    state.id = payload.id;
    state.email = payload.email;
    state.role = payload.role;
    state.groups = payload.groups;
    state.ccb_projects = JSON.stringify(payload.ccbProjects);
    state.avatar = payload.avatar;
  },
  auth_error(state) {
    state.status = 'error';
    state.token = '';
  },
  logout(state) {
    state.status = '';
    state.token = '';
    state.user = '';
    state.id = '';
    state.email = '';
    state.role = '';
    state.groups = '';
    state.ccb_projects = '';
    state.avatar = '';
  }
  },
  actions: {
    async login({ commit }, loginUser) {
      commit("auth_request");

      try {
        // 1) Login request
        const url = DatabaseLib.getEndpoint("strapiDatabase") + "api/auth/local";
        const res = await axios.post(url, {
          identifier: loginUser.email,
          password: loginUser.password,
        });

        const token = res.data.jwt;
        const user = res.data.user;

        // 2) Get full user profile
        const profileUrl =
          DatabaseLib.getEndpoint("strapiDatabase") +
          `api/users?filters[username][$eq][0]=${user.username}&populate[1]=role&populate[2]=profilePic&populate[3]=groups&populate[4]=ccb_projects`;

        const profile = await axios.get(profileUrl, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const u = profile.data[0];

        // Build groups array
        const groups = u.groups.map((g) => g.name);

        const ccbProjects = u.ccb_projects;

        // Build avatar url safely
        const avatar = u.profilePic?.[0]?.url
          ? DatabaseLib.getEndpoint("strapiDatabase").slice(0, -1) + u.profilePic[0].url
          : "";

        // 3) Save everything to sessionStorage
        sessionStorage.setItem("token", token);
        sessionStorage.setItem("user", user.username);
        sessionStorage.setItem("id", user.id);
        sessionStorage.setItem("email", user.email);
        sessionStorage.setItem("role", u.role.name);
        sessionStorage.setItem("groups", JSON.stringify(groups));
        sessionStorage.setItem("ccb_projects", JSON.stringify(ccbProjects));
        sessionStorage.setItem("avatar", avatar);

        // 4) Commit Vuex mutation
        commit("auth_success", {
          token,
          user: user.username,
          id: user.id,
          email: user.email,
          role: u.role.name,
          groups,
          ccbProjects,
          avatar,
        });

        // 5) Set axios default header correctly
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

        // 6) Update lastLogin (does not block login success)
        DatabaseLib.putRequest("strapiDatabase", "users", token, user.id, {
          lastLogin: new Date(),
        });

        return res; // return login result
      } catch (error) {
        commit("auth_error");
        sessionStorage.clear();
        delete axios.defaults.headers.common["Authorization"];
        throw error;
      }
    },

    logout({ commit }) {
      return new Promise((resolve) => {
        commit("logout");
        sessionStorage.clear();
        delete axios.defaults.headers.common["Authorization"];
        resolve();
      });
    },

  },	
  methods:{

  },
  modules: {
  },
  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    getUser: state => state.user,
    getToken: state => state.token,
    getId: state => state.id,
    getEmail: state => state.email,
    getRole: state => state.role,
    getGroups: state => state.groups,
    getCCBGroups: state => state.ccb_projects,
    getAvatar: state => state.avatar,
  }
});
